import {
  EnumImageSizeType,
  EnumsShowStatus,
  imageProcesserSize
} from "src/constant";
import { FTCanvasStore, FTImageStore, FTUserStore } from "src/store";
import { IconPlus, ReGenerateIcon } from "src/assets";
import React, { useEffect, useState } from "react";
import {
  actionClickUp,
  actionImportImageClick,
  actionImportImageClose,
  actionImportImageResult,
  actionImportImageShow
} from "src/analyze/actions";
import { hanldelFTUserProfile, utils } from "src/utils";
import { useImageStoreFN, useIsMobile, useLanguage, useUserStoreFN } from "src/hooks";

/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2021-12-06 14:27:22
 * @Description:
 */
import { DownloadWithPopover } from "src/components";
import PostCommunity from "src/components/PostCommunity/PostCommunity";
import SelectImagesComp from "src/components/SelectImage";
import VideoLinkWithPopover from "src/components/LinkToVideoPopover";
import { autorun } from "mobx";
import clsx from "clsx";
import { message } from "antd";
import styles from "./FTCanvasPanel.module.scss";

interface IProps {
  drawCanvasResize: () => void;
  download: (type: EnumImageSizeType, option) => void;
}
const FTCanvasPanel = (props: IProps) => {
  const [showDownload, setShowDownload] = React.useState(false);
  const [showWaterMark, setShowWaterMark] = React.useState(false);
  const [width, setWidth] = React.useState(0);
  const [height, setHeight] = React.useState(0);
  const [isLogin, setIsLogin] = React.useState(false);

  const [smallSize, setSmallSize] = React.useState({
    width: 0,
    height: 0
  });
  const [largerSize, setLargerSize] = React.useState({
    width: 0,
    height: 0
  });
  const isMobile = useIsMobile();
  const [result, setResult] = useState(FTImageStore.showStatus);
  const [curEffect, setCurEffecit] = useState<any>();
  const [isAigc, setIsAigc] = useState(false);
  /**这次生成是不是登录生成的 */
  const [hasLoginGenerate, setHasLoginGenerate] = useState(false);

  useEffect(() => {
    autorun(() => {
      setCurEffecit(FTImageStore.currentEffect);
    });
    autorun(() => {
      setIsLogin(!!FTUserStore.userInfo);
      setResult(FTImageStore.showStatus);
      setIsAigc(FTImageStore.currentEffect?.aigc ?? false);
      // setTaskId(FTImageStore.taskId);
      setHasLoginGenerate(FTImageStore.recordsHasLoginGenerate);
      let { showDownload, isMobile } = FTCanvasStore;
      let { isVip } = FTUserStore;
      let { currentEffect, currentSize, acturalSize, resultSize } =
        FTImageStore;
      let smallScale = utils.aspectFitScale(
        currentSize.width,
        currentSize.height,
        imageProcesserSize.IMAGE_SIDE_VALUE
      );
      let largerScale = utils.aspectFitScale(
        acturalSize.width,
        acturalSize.height,
        Number(imageProcesserSize.SUPPER_RESOLUTION_HIGH_ID)
      );
      setWidth(resultSize.width || currentSize.width);
      setHeight(resultSize.height || currentSize.height);
      setShowDownload(showDownload);
      setShowWaterMark(!isVip && currentEffect);
      setSmallSize({
        width: Math.round(currentSize.width * smallScale),
        height: Math.round(currentSize.height * smallScale)
      });
      setLargerSize({
        width: Math.round(acturalSize.width * largerScale),
        height: Math.round(acturalSize.height * largerScale)
      });
    });
  }, []);

  const changeImage = async (files?) => {
    actionImportImageClick("change_image");
    actionImportImageShow("change_image");
    let img = files
      ? files
      : await utils.selectImageFile({ multiple: false, useFocus: false });
    actionImportImageClose("change_image");

    if (img && img.length > 0) {
      actionImportImageResult("change_image", true);
      hanldelFTUserProfile();
      FTCanvasStore.changeLoading(true);
      FTImageStore.effectElement = null;
      FTImageStore.uploadFaceUrl = null;
      FTImageStore.uploadImageUrl = null;
      FTImageStore.artUploadImageUrl = null;
      FTImageStore.artHDUploadImageUrl = null;
      FTImageStore.resultSize = {
        width: 0,
        height: 0
      };
      const [firstImg] = img;
      const checkResult = await utils.checkImage(firstImg);
      if (!checkResult.result) {
        message.error(t(checkResult.message));
        FTCanvasStore.changeLoading(false);
        return;
      }

      let {
        canvas: imageElement,
        acturalSize,
        currentSize
      } = await utils.getImageFromFile(img[0]);
      FTImageStore.uploadImageUrl = null;
      FTImageStore.setCurrentImageElement(
        imageElement,
        currentSize,
        acturalSize
      );
      FTImageStore.setCurrentImage(img[0]);
      props.drawCanvasResize();
      FTCanvasStore.changeLoading(false);
      FTImageStore.currentEffect = null;
      // change images 时 只上传图片，不应用特效
      //if (
      //  FTImageStore.currentEffect &&
      //  FTImageStore.currentEffect !== 'original'
      //) {
      //  actionClickUp(
      //    utils.toFixed(FTImageStore.currentEffect.id, 0),
      //    FTImageStore.currentEffect.name,
      //  );
      //  FTImageStore.getGoartEffect(FTImageStore.currentEffect);
      //}
    } else {
      actionImportImageResult("goart_change_image", false);
    }
  };
  const handleDownload = (type: EnumImageSizeType, option) => {
    props.download(type, option);
  };

  const { t } = useLanguage();

  return (
    <div
      className='canvas_panel'
      onClick={(e) => {
        e.stopPropagation();
        // e.preventDefault();
      }}>
      <div className={styles["fra"]}>
        <div
          onClick={(e) => {
            e.stopPropagation();
            changeImage();
          }}
          className={clsx(
            styles["fra-left"],
            isMobile && styles["fra-left-ismobile"]
          )}>
          <IconPlus />
          {!isMobile && <span>{t("goart_change_image")}</span>}
        </div>
        {!isMobile && (
          <SelectImagesComp
            onChange={(file) => {
              changeImage([file]);
            }}
            className={styles["fra-right"]}
          />
        )}
      </div>
      {/* //重新生成 */}
      {isMobile && result === EnumsShowStatus.result && curEffect?.aigc && (
        <div
          onClick={(el) => {
            el.stopPropagation();
            // delete FTImageStore.usedEffect[curEffect?.id];
            actionClickUp(utils.toFixed(curEffect.id, 0), curEffect.enName, {
              button_position: "goart_regenerate",
              category_id: curEffect.classifyId,
              category_name: curEffect.firstCategoryEn
            });
            FTImageStore.getGoartEffect(curEffect, "retry_button", true);
          }}
          className={styles["regenerate"]}>
          <ReGenerateIcon width={16} />
          <span>{t("goart_regenerate")}</span>
        </div>
      )}

      {/* <FTButton className='canvas_panel_open' onClick={() => changeImage()}>
        <IconPlus />
        <span>{t("goart_change_image")}</span>
      </FTButton> */}
      {/* {isMobile && <FTWatermark theme='text' />} */}
      <div className='canvas_panel_right'>
        {isAigc &&  <PostCommunity />}
        {isAigc && <VideoLinkWithPopover />}
        <DownloadWithPopover
          width={width}
          height={height}
          onDownloadHD={(type) => handleDownload(EnumImageSizeType.HD, type)}
          onDownloadPreview={(type) =>
            handleDownload(EnumImageSizeType.Preview, type)
          }
        />
      </div>
    </div>
  );
};

export default FTCanvasPanel;
